// @ts-check

/**
 * @file Creates the local options table.
 */
import Migration from "velocious/build/src/database/migration/index.js"

/** Create the local `options` table used as the frontend's key-value store. */
export default class CreateOptions extends Migration {
  /** Creates the options table when the local database is missing it. */
  async up() {
    if (!await this.tableExists("options")) {
      await this.createTable("options", {id: {type: "uuid"}}, (t) => {
        t.string("key", {null: false})
        t.text("value")
        t.timestamps()
      })

      await this.addIndex("options", ["key"], {unique: true})
    }
  }

  /** Removes the local options table. */
  async down() {
    await this.removeTable("options")
  }
}
